import React, { Suspense } from 'react';
import { Outlet, Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { LinearProgress } from '@material-ui/core';
import { Topbar } from '../Auth/components';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 1 auto',
    overflowY: 'auto',
    paddingTop: 56,
    [theme.breakpoints.up('sm')]: {
      paddingTop: 64,
    },
  },
  footer: {
    flexShrink: 0,
    borderTop: '1px solid #e8ecef',
    backgroundColor: '#fff',
    padding: '10px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 8,
  },
  footerCopy: { fontSize: '0.72rem', color: '#b0bec5' },
  footerLinks: { display: 'flex', alignItems: 'center', gap: 4 },
  footerLink: {
    fontSize: '0.72rem',
    color: '#90a4ae',
    textDecoration: 'none',
    padding: '2px 8px',
    borderRadius: 4,
    '&:hover': { color: '#682622', backgroundColor: '#f4f6f8' },
  },
  footerDot: { width: 3, height: 3, borderRadius: '50%', backgroundColor: '#cfd8dc', flexShrink: 0 },
}));

const PublicFooter = ({ classes }) => (
  <footer className={classes.footer}>
    <span className={classes.footerCopy}>© {new Date().getFullYear()} CGIAR / ILRI · TDGG WEB</span>
    <nav className={classes.footerLinks}>
      <RouterLink className={classes.footerLink} to="/info/about">About</RouterLink>
      <span className={classes.footerDot} />
      <RouterLink className={classes.footerLink} to="/info/privacy-policy">Privacy Policy</RouterLink>
      <span className={classes.footerDot} />
      <RouterLink className={classes.footerLink} to="/info/data-governance">Data &amp; Governance</RouterLink>
    </nav>
  </footer>
);

const Public = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Topbar />
      <main className={classes.content}>
        <Suspense fallback={<LinearProgress />}>
          <Outlet />
        </Suspense>
      </main>
      <PublicFooter classes={classes} />
    </div>
  );
};

export default Public;
